import { render } from "./App.vue?vue&type=template&id=03a5caf8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=03a5caf8&lang=css"

import exportComponent from "D:\\VueAdminPro\\villagepc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__